export default function (name, url) {
  let src = url || window.location.href;
  if (name && src) {
    var r = new RegExp("(\\?|#|&|^)" + name + "=([^&^#]*)(#|&|$)");
    var m = src.match(r);
    return !m ? "" : decodeURIComponent(m[2]);
  }
  return "";
}
